(ns app.front.ui.blip
  (:require [app.front.ui.status :as ui-status]
            [app.front.ui.transitions :as transitions]
            [reagent.core :as r]))

(defn blip
  "Wrap a component with the possibility of triggering a blip, or a short-lived
  text popup.

  The parameter `make-children` should be a function that takes one parameter,
  a function that you can call with a string that will be blipped.

  Optional second argument accepts `:status` for status background and text colors.

  [blib
   (fn [show-blip]
     [:button {:on-click #(blip some-str-or-component)} ...]"
  [make-children & [{:keys [status]}]]
  (r/with-let [*content (r/atom nil)
               *visible? (r/atom false)]
    [:div.relative
     [transitions/fade-out-up {:in @*visible?}
      [:div.absolute.p-1.rounded.font-bold
       {:style {:top "-20px"}
        :class (if status
                 (ui-status/status->bg-text-color-classes status)
                 "bg-yellow-200 text-yellow-800")}
       @*content]]
     (make-children (fn [text]
                      (reset! *content text)
                      (reset! *visible? true)
                      (r/after-render #(reset! *visible? false))))]))
